import React from 'react';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';
const Pagination = (props) => {
  const handlePagination = (current) => {
    props.pagination(current);
  };
  return (
    <>
      <div className="flex items-center justify-between border-t border-gray-200 px-4 py-3 sm:px-6">
        <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
          <div></div>
          <div>
            <nav
              className="isolate inline-flex -space-x-px rounded-md shadow-sm"
              aria-label="Pagination"
            >
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  handlePagination(props.current - 1);
                }}
                className={`'relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0' 
                  ${props.current === 1 ? 'pointer-events-none' : 'cursor-pointer'}`}
              >
                <span className="sr-only">Previous</span>
                <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
              </Link>
              {props.total < 7 ? (
                <>
                  {Array.apply(0, Array(props.total)).map((arr, i) => (
                    <Link
                      key={i}
                      onClick={(e) => {
                        e.preventDefault();
                        handlePagination(i + 1);
                      }}
                      className={`pagination-flex-ring-btn px-4 py-2 font-semibold text-sm text-gray-900
                        ${
                          props.current === i + 1
                            ? 'pointer-events-none dark:text-black dark:bg-[#97c05b] bg-[#97c05b]'
                            : 'dark:text-white cursor-pointer'
                        }
                  `}
                    >
                      {i + 1}
                    </Link>
                  ))}
                </>
              ) : props.current % 5 >= 0 &&
                props.current > 4 &&
                props.current + 2 < props.total ? (
                <>
                  <Link className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer">
                    1
                  </Link>
                  <Link className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer">
                    ...
                  </Link>

                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      handlePagination(props.current - 1);
                    }}
                    className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer"
                  >
                    {props.current - 1}
                  </Link>

                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      handlePagination(props.current);
                    }}
                    className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer"
                  >
                    {props.current}
                  </Link>

                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      handlePagination(props.total + 1);
                    }}
                    className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer"
                  >
                    {props.current + 1}
                  </Link>
                  <Link className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer">
                    ...
                  </Link>

                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      handlePagination(props.total);
                    }}
                    className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer"
                  >
                    {props.total}
                  </Link>
                </>
              ) : props.current % 5 >= 0 &&
                props.current > 4 &&
                props.current + 2 >= props.total ? (
                <>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      handlePagination(1);
                    }}
                    className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer"
                  >
                    1
                  </Link>

                  <Link className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer">
                    ...
                  </Link>

                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      handlePagination(props.total - 3);
                    }}
                    className={`relative inline-flex  items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0
                          ${
                            props.current === props.total - 3
                              ? 'pointer-events-none dark:hover:bg-gray-500 dark:text-black dark:bg-[#97c05b] bg-[#97c05b]'
                              : 'dark:text-white cursor-pointer'
                          }
                          `}
                  >
                    {props.total - 3}
                  </Link>

                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      handlePagination(props.total - 2);
                    }}
                    className={`relative inline-flex  items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0
                          ${
                            props.current === props.total - 2
                              ? 'pointer-events-none dark:hover:bg-gray-500 dark:text-black dark:bg-[#97c05b] bg-[#97c05b]'
                              : 'dark:text-white cursor-pointer'
                          }
                          `}
                  >
                    {props.total - 2}
                  </Link>

                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      handlePagination(props.total - 1);
                    }}
                    className={`relative inline-flex  items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0
                          ${
                            props.current === props.total - 1
                              ? 'pointer-events-none dark:hover:bg-gray-500 dark:text-black dark:bg-[#97c05b] bg-[#97c05b]'
                              : 'dark:text-white cursor-pointer'
                          }`}
                  >
                    {props.total - 1}
                  </Link>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      handlePagination(props.total);
                    }}
                    className={`relative inline-flex  items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0
                          ${
                            props.current === props.total
                              ? 'pointer-events-none dark:hover:bg-gray-500 dark:text-black dark:bg-[#97c05b] bg-[#97c05b]'
                              : 'dark:text-white cursor-pointer'
                          }`}
                  >
                    {props.total}
                  </Link>
                </>
              ) : (
                <>
                  {Array.apply(0, Array(5)).map((arr, i) => (
                    <Link
                      key={i}
                      onClick={(e) => {
                        e.preventDefault();
                        handlePagination(i + 1);
                      }}
                      className={`relative inline-flex  items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0
                            ${
                              props.current === i + 1
                                ? 'pointer-events-none dark:text-black dark:bg-[#97c05b] bg-[#97c05b]'
                                : 'dark:text-white cursor-pointer'
                            }`}
                    >
                      {i + 1}
                    </Link>
                  ))}
                  <Link className="relative inline-flex dark:text-white items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer">
                    ...
                  </Link>

                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      handlePagination(props.total);
                    }}
                    className="relative inline-flex dark:text-white  items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0 cursor-pointer"
                  >
                    {props.total}
                  </Link>
                </>
              )}
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  handlePagination(props.current + 1);
                }}
                className={`relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:hover:bg-gray-500 focus:z-20 focus:outline-offset-0
                  ${props.current === props.total ? 'pointer-events-none' : 'cursor-pointer'}`}
              >
                <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pagination;
